const isTabletSize = (): boolean => {
  const windowWidth = window.innerWidth;
  const tabletSize = 820;

  return windowWidth <= tabletSize;
};

export default isTabletSize;
